/* BroSellers — thème Shopify : panier AJAX, FAB, compte à rebours, variantes, galerie */
(function () {
  var money = function (cents) { return Math.round(cents / 100).toLocaleString('fr-FR') + ' FCFA'; };

  /* ── FAB + badge ── */
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var fab = document.getElementById('cart-fab');
      var count = document.getElementById('cart-fab-count');
      var total = document.getElementById('cart-fab-total');
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      if (!fab) return;
      if (cart.item_count === 0) { fab.classList.remove('visible'); return; }
      fab.classList.add('visible');
      if (count) count.textContent = cart.item_count;
      if (total) total.textContent = money(cart.total_price);
      var btn = fab.querySelector('.cart-fab-btn');
      if (btn) { btn.classList.remove('shake'); void btn.offsetWidth; btn.classList.add('shake'); }
    });
  }

  /* ── Synchro du panier flottant au chargement (état réel Shopify) ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCart);
  } else {
    refreshCart();
  }

  /* ── Ajout au panier (boutons data-add-to-cart) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    if (btn.dataset.busy === '1') return;           /* anti double-clic */
    btn.dataset.busy = '1';
    btn.disabled = true;
    var original = btn.innerHTML;                   /* préserve l'icône SVG */
    btn.classList.add('is-adding');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      refreshCart();
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.innerHTML = original;
        btn.disabled = false;
        btn.dataset.busy = '';
      }, 1100);
    }).catch(function () {
      btn.classList.remove('is-adding');
      btn.innerHTML = original;
      btn.disabled = false;
      btn.dataset.busy = '';
    });
  });

  /* ── Formulaire produit en AJAX ── */
  var ppForm = document.getElementById('pp-form');
  if (ppForm) {
    ppForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = ppForm.querySelector('.pp-add');
      submitBtn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(ppForm) })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          submitBtn.textContent = '✓ Ajouté au panier';
          setTimeout(function () { submitBtn.textContent = 'Ajouter au panier'; submitBtn.disabled = false; }, 1600);
          refreshCart();
        })
        .catch(function () { submitBtn.disabled = false; ppForm.submit(); });
    });
  }

  /* ── Sélecteur de variantes ── */
  var variantsEl = document.querySelector('[data-variants]');
  if (variantsEl) {
    var variants = JSON.parse(variantsEl.textContent);
    var selects = document.querySelectorAll('.pp-opt');
    var input = document.querySelector('[data-variant-input]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    function syncVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });
      if (!match) return;
      input.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      var add = document.querySelector('.pp-add');
      if (add) { add.disabled = !match.available; add.textContent = match.available ? 'Ajouter au panier' : 'Épuisé'; }
    }
    selects.forEach(function (s) { s.addEventListener('change', syncVariant); });
  }

  /* ── Galerie produit ── */
  document.querySelectorAll('.pp-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.getElementById('pp-main-img');
      if (main) main.src = t.getAttribute('data-full');
      document.querySelectorAll('.pp-thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  /* ── Compte à rebours Offres du jour ── */
  var timer = document.querySelector('[data-deal-timer]');
  if (timer) {
    var hours = parseInt(timer.getAttribute('data-hours') || '4', 10);
    var key = 'bro_deal_end';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!end || end < Date.now()) { end = Date.now() + hours * 3600000; try { sessionStorage.setItem(key, end); } catch (e) {} }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    (function tick() {
      var d = Math.max(0, end - Date.now());
      timer.querySelector('[data-t="h"]').textContent = pad(Math.floor(d / 3600000));
      timer.querySelector('[data-t="m"]').textContent = pad(Math.floor(d % 3600000 / 60000));
      timer.querySelector('[data-t="s"]').textContent = pad(Math.floor(d % 60000 / 1000));
      if (d === 0) { end = Date.now() + hours * 3600000; try { sessionStorage.setItem(key, end); } catch (e) {} }
      setTimeout(tick, 1000);
    })();
  }

  /* ── Commande WhatsApp depuis le panier ── */
  var waBtn = document.querySelector('[data-wa-checkout]');
  if (waBtn) {
    waBtn.addEventListener('click', function (e) {
      e.preventDefault();
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var lines = cart.items.map(function (i) {
          return '- ' + i.product_title + (i.variant_title && i.variant_title !== 'Default Title' ? ' (' + i.variant_title + ')' : '') +
                 ' x' + i.quantity + ' = ' + money(i.final_line_price);
        }).join('\n');
        var msg = 'Bonjour BroSellers ! Je voudrais commander :\n' + lines + '\nTOTAL : ' + money(cart.total_price);
        window.open('https://wa.me/' + (window.BRO && window.BRO.wa ? window.BRO.wa : '') + '?text=' + encodeURIComponent(msg), '_blank');
      });
    });
  }

  /* ── Pilules catégories (repli mobile) ── */
  var catsToggle = document.querySelector('[data-cats-toggle]');
  if (catsToggle) {
    catsToggle.addEventListener('click', function () {
      catsToggle.closest('.cats').classList.toggle('open');
      catsToggle.textContent = catsToggle.closest('.cats').classList.contains('open') ? '− Réduire' : '+ Toutes les catégories';
    });
  }

  refreshCart();
})();

/* ── Tiroir mobile ── */
(function () {
  function setDrawer(open) { document.body.classList.toggle('drawer-open', open); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { setDrawer(true); }
    if (e.target.closest('[data-drawer-close]')) { setDrawer(false); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });
})();

/* ── Carrousels : flèches ── */
document.addEventListener('click', function (e) {
  var prev = e.target.closest('[data-car-prev]');
  var next = e.target.closest('[data-car-next]');
  if (!prev && !next) return;
  var car = (prev || next).closest('[data-carousel]');
  var track = car && car.querySelector('[data-car-track]');
  if (!track) return;
  var step = Math.max(track.clientWidth * 0.8, 240);
  track.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
});

/* ── Sélecteur d'option obligatoire avant ajout au panier ── */
(function () {
  var fmt = function (cents) { return Math.round(cents / 100).toLocaleString('fr-FR') + ' FCFA'; };
  var current = null;

  function el(sel) { return document.querySelector(sel); }

  function close() { document.body.classList.remove('vp-open'); current = null; }

  function currentVariant() {
    if (!current) return null;
    var selects = document.querySelectorAll('.vp-select');
    var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
    return current.variants.find(function (v) {
      return chosen.every(function (val, i) { return v['option' + (i + 1)] === val; });
    }) || null;
  }

  function sync() {
    var v = currentVariant();
    var add = el('[data-vp-add]');
    var price = el('.vp-price');
    if (!v) { add.disabled = true; add.textContent = 'Indisponible'; return; }
    price.textContent = fmt(v.price);
    add.disabled = !v.available;
    add.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
    add.setAttribute('data-variant-id', v.id);
    if (v.featured_image && v.featured_image.src) el('.vp-img').src = v.featured_image.src;
  }

  function open(prod) {
    current = prod;
    el('.vp-title').textContent = prod.title;
    var img = prod.featured_image || (prod.images && prod.images[0]) || '';
    el('.vp-img').src = typeof img === 'string' ? img : (img.src || '');
    var wrap = el('.vp-opts');
    wrap.innerHTML = '';
    var names = (prod.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    names.forEach(function (name, i) {
      var vals = [];
      prod.variants.forEach(function (v) {
        var val = v['option' + (i + 1)];
        if (val && vals.indexOf(val) < 0) vals.push(val);
      });
      var lbl = document.createElement('label');
      lbl.className = 'vp-label'; lbl.textContent = name;
      var sel = document.createElement('select');
      sel.className = 'vp-select';
      vals.forEach(function (v) {
        var o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o);
      });
      sel.addEventListener('change', sync);
      wrap.appendChild(lbl); wrap.appendChild(sel);
    });
    sync();
    document.body.classList.add('vp-open');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-variant-picker]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      var handle = btn.getAttribute('data-product-handle');
      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(open)
        .catch(function () { window.location.href = '/products/' + handle; });
      return;
    }
    if (e.target.closest('[data-vp-close]')) { close(); return; }
    var add = e.target.closest('[data-vp-add]');
    if (add) {
      var id = add.getAttribute('data-variant-id');
      if (!id) return;
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error();
        add.textContent = '✓ Ajouté au panier !';
        fetch('/cart.js').then(function (x) { return x.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          var fab = document.getElementById('cart-fab');
          if (fab && cart.item_count > 0) {
            fab.classList.add('visible');
            var count = document.getElementById('cart-fab-count');
            var total = document.getElementById('cart-fab-total');
            if (count) count.textContent = cart.item_count;
            if (total) total.textContent = fmt(cart.total_price);
          }
        });
        setTimeout(function () { close(); add.disabled = false; add.textContent = 'Ajouter au panier'; }, 900);
      }).catch(function () { add.disabled = false; });
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

/* ── Consentement cookies ── */
(function () {
  var KEY = 'bro_consent_v1';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function save(c) { try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {} window.broConsent = c; hideAll(); }
  function el(s) { return document.querySelector(s); }
  function hideAll() {
    var b = el('[data-ck-banner]'); if (b) b.hidden = true;
    var m = el('[data-ck-modal]'); if (m) m.hidden = true;
    var o = el('[data-ck-overlay], .ck-overlay'); if (o) o.hidden = true;
  }
  function openPrefs() {
    var c = read() || { analytics: false, marketing: false };
    document.querySelectorAll('[data-ck-cat]').forEach(function (i) { i.checked = !!c[i.getAttribute('data-ck-cat')]; });
    el('.ck-overlay').hidden = false;
    el('[data-ck-modal]').hidden = false;
  }
  document.addEventListener('DOMContentLoaded', function () {
    var c = read();
    window.broConsent = c;
    if (!c) { var b = el('[data-ck-banner]'); if (b) b.hidden = false; }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ck-accept]') && !e.target.closest('[data-ck-save]')) { save({ essential: true, analytics: true, marketing: true, ts: Date.now() }); }
    if (e.target.closest('[data-ck-refuse]')) { save({ essential: true, analytics: false, marketing: false, ts: Date.now() }); }
    if (e.target.closest('[data-cookie-prefs]')) { e.preventDefault(); openPrefs(); }
    if (e.target.closest('[data-ck-close]')) { el('[data-ck-modal]').hidden = true; el('.ck-overlay').hidden = true; }
    if (e.target.closest('[data-ck-save]')) {
      var c = { essential: true, ts: Date.now() };
      document.querySelectorAll('[data-ck-cat]').forEach(function (i) { c[i.getAttribute('data-ck-cat')] = i.checked; });
      save(c);
    }
  });
})();

/* ── Favoris (liés au compte client) ── */
(function () {
  var cid = window.BRO && window.BRO.customerId;
  var KEY = cid ? ('bro_wish_' + cid) : null;
  function read() { if (!KEY) return []; try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(list) { if (KEY) try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} refreshUI(list); }
  function refreshUI(list) {
    list = list || read();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      b.classList.toggle('active', list.indexOf(b.getAttribute('data-handle')) > -1);
    });
    document.querySelectorAll('[data-wish-count]').forEach(function (n) {
      n.textContent = list.length;
      n.style.display = list.length > 0 ? '' : 'none';
    });
  }
  function fmt(cents) { return Math.round(cents / 100).toLocaleString('fr-FR') + ' FCFA'; }

  document.addEventListener('DOMContentLoaded', function () { refreshUI(); loadFavPage(); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      if (!cid) {
        var login = document.querySelector('[data-wm-login]');
        if (login) {
          var ret = encodeURIComponent(window.location.pathname + window.location.search);
          login.href = login.href.split('?')[0] + '?return_url=' + ret;
        }
        document.body.classList.add('wm-open');
        return;
      }
      var h = b.getAttribute('data-handle');
      var list = read();
      var i = list.indexOf(h);
      if (i > -1) { list.splice(i, 1); } else { list.push(h); }
      save(list);
      var card = b.closest('[data-fav-card-item]');
      if (card && i > -1) { card.remove(); updateFavCount(); }
    }
    if (e.target.closest('[data-wm-close]')) { document.body.classList.remove('wm-open'); }
  });

  function updateFavCount() {
    var n = document.querySelector('[data-fav-count]');
    var grid = document.querySelector('[data-fav-grid]');
    if (!n || !grid) return;
    var count = grid.querySelectorAll('[data-fav-card-item]').length;
    n.textContent = count + ' produit' + (count > 1 ? 's' : '');
    if (count === 0) grid.innerHTML = '<p class="empty">Aucun favori pour le moment. Touchez le ❤️ sur un produit pour l\u2019enregistrer ici.</p>';
  }

  function loadFavPage() {
    var grid = document.querySelector('[data-fav-grid]');
    var tpl = document.querySelector('[data-fav-card]');
    if (!grid || !tpl) return;
    var list = read();
    grid.innerHTML = '';
    if (!list.length) { updateFavCount(); return; }
    var done = 0;
    list.forEach(function (h) {
      fetch('/products/' + h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        node.setAttribute('data-fav-card-item', '');
        node.querySelectorAll('[data-t-link],[data-t-link2],[data-t-link3]').forEach(function (a) { a.href = '/products/' + h; });
        var img = node.querySelector('[data-t-img]');
        var src = p.featured_image || (p.images && p.images[0]) || '';
        img.src = typeof src === 'string' ? src : (src.src || '');
        img.alt = p.title;
        node.querySelector('[data-t-name]').textContent = p.title;
        node.querySelector('[data-t-price]').textContent = fmt(p.price);
        if (!p.available) node.querySelector('[data-t-soldout]').style.display = '';
        node.querySelector('[data-wish]').setAttribute('data-handle', h);
        node.querySelector('[data-wish]').classList.add('active');
        grid.appendChild(node);
      }).catch(function () {}).finally(function () {
        done++; if (done === list.length) updateFavCount();
      });
    });
  }
})();

/* ── Indicateur livraison gratuite : mise à jour dynamique ── */
window.broUpdateShip = function (totalCents) {
  var box = document.querySelector('[data-ship-progress]');
  if (!box) return;
  var threshold = parseInt(box.getAttribute('data-threshold'), 10) || 1000000;
  var msg = box.querySelector('[data-ship-msg]');
  var fill = box.querySelector('[data-ship-fill]');
  var pct = Math.min(100, Math.round(totalCents * 100 / threshold));
  if (fill) fill.style.width = pct + '%';
  if (!msg) return;
  if (totalCents >= threshold) {
    msg.className = 'ship-msg ship-ok';
    msg.innerHTML = '🎉 Livraison gratuite disponible à Abidjan – zone standard.';
  } else {
    var rest = Math.round((threshold - totalCents) / 100).toLocaleString('fr-FR');
    msg.className = 'ship-msg';
    msg.innerHTML = 'Plus que <strong>' + rest + ' FCFA</strong> pour profiter de la livraison gratuite à Abidjan.';
  }
};
document.addEventListener('cart:updated', function (e) {
  if (e.detail && typeof e.detail.total_price === 'number') window.broUpdateShip(e.detail.total_price);
});

/* ── Tiroir : recherche animée + sous-menu catégories ── */
(function () {
  function drawer() { return document.querySelector('.drawer'); }
  var t = null;

  function render(results, q, box) {
    if (!box) box = document.querySelector('[data-dsearch-results]');
    if (!box) return;
    if (!results) { box.innerHTML = ''; return; }
    var html = '';
    if (results.length === 0) {
      html = '<p class="dsr-none">Aucun produit trouvé pour « ' + q.replace(/</g, '&lt;') + ' »</p>';
    } else {
      results.forEach(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        var price = p.price ? (parseFloat(p.price).toLocaleString('fr-FR') + ' FCFA') : '';
        html += '<a class="dsr" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '<span class="dsr-i"><span class="dsr-t">' + p.title.replace(/</g, '&lt;') + '</span>' +
          (price ? '<span class="dsr-p">' + price + '</span>' : '') + '</span></a>';
      });
    }
    html += '<a class="dsr-all" href="/search?q=' + encodeURIComponent(q) + '">Voir tous les résultats →</a>';
    box.innerHTML = html;
  }

  document.addEventListener('click', function (e) {
    var d = drawer();
    if (!d) return;
    if (e.target.closest('[data-search-toggle]')) {
      e.preventDefault();
      d.classList.toggle('search-open');
      if (d.classList.contains('search-open')) {
        var i = d.querySelector('[data-dsearch-input]');
        setTimeout(function () { if (i) i.focus(); }, 260);
      }
      return;
    }
    if (e.target.closest('[data-cats-open]')) { e.preventDefault(); document.body.classList.add('drawer-open'); d.classList.add('show-cats'); return; }
    if (e.target.closest('[data-cats-back]')) { d.classList.remove('show-cats'); return; }
    if (e.target.closest('[data-dsearch-clear]')) {
      var wrap = e.target.closest('.dsearch');
      var inp = wrap && wrap.querySelector('[data-dsearch-input]');
      if (inp) { inp.value = ''; inp.focus(); }
      e.target.closest('[data-dsearch-clear]').hidden = true;
      render(null, '', wrap && wrap.querySelector('[data-dsearch-results]'));
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { d.classList.remove('show-cats', 'search-open'); }
    var ht = e.target.closest('[data-hsearch-toggle]');
    if (ht) {
      e.preventDefault();
      var hp = document.querySelector('[data-hsearch]');
      if (hp) {
        hp.classList.add('open');
        setTimeout(function () {
          var hi = hp.querySelector('[data-dsearch-input]');
          if (hi) hi.focus();
        }, 120);
      }
      return;
    }
    if (e.target.closest('[data-hsearch-close]')) {
      var hp2 = document.querySelector('[data-hsearch]');
      if (hp2) hp2.classList.remove('open');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var hp = document.querySelector('[data-hsearch]');
      if (hp) hp.classList.remove('open');
    }
  });

  document.addEventListener('input', function (e) {
    var inp = e.target.closest('[data-dsearch-input]');
    if (!inp) return;
    var wrap = inp.closest('.dsearch');
    var box = wrap && wrap.querySelector('[data-dsearch-results]');
    var clear = wrap && wrap.querySelector('[data-dsearch-clear]');
    if (clear) clear.hidden = inp.value.length === 0;
    clearTimeout(t);
    var q = inp.value.trim();
    if (q.length < 2) { render(null); return; }
    t = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (data) {
          var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(prods, q, box);
        })
        .catch(function () { render(null, '', box); });
    }, 260);
  });
})();

/* ── Recherche flottante au défilement ── */
(function () {
  var btn = document.querySelector('[data-fsearch]');
  if (!btn) return;
  btn.hidden = false;
  var ticking = false;
  function update() {
    document.body.classList.toggle('fsearch-show', window.scrollY > 120);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
  btn.addEventListener('click', function () {
    if (window.innerWidth > 820) {
      var hp = document.querySelector('[data-hsearch]');
      if (hp) {
        hp.classList.add('open');
        setTimeout(function () {
          var hi = hp.querySelector('[data-dsearch-input]');
          if (hi) hi.focus();
        }, 120);
        return;
      }
      window.location.href = '/search';
      return;
    }
    /* même recherche que le menu mobile : tiroir + barre animée */
    document.body.classList.add('drawer-open');
    var d = document.querySelector('.drawer');
    if (d) {
      d.classList.add('search-open');
      setTimeout(function () {
        var i = d.querySelector('[data-dsearch-input]');
        if (i) i.focus();
      }, 300);
    }
  });
})();

/* ── BroDeals : défilement automatique + actualisation à la tranche de 2h ── */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Défilement auto : une carte toutes les 4,5 s, pause au survol/interaction */
  document.querySelectorAll('[data-car-autoplay]').forEach(function (car) {
    if (reduced) return;
    var track = car.querySelector('[data-car-track]');
    if (!track) return;
    var paused = false, resumeT = null;
    function hold(ms) {
      paused = true;
      clearTimeout(resumeT);
      resumeT = setTimeout(function () { paused = false; }, ms);
    }
    car.addEventListener('mouseenter', function () { paused = true; clearTimeout(resumeT); });
    car.addEventListener('mouseleave', function () { paused = false; });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { hold(6000); }, { passive: true });
    });
    car.addEventListener('click', function (e) {
      if (e.target.closest('[data-car-prev],[data-car-next]')) hold(6000);
    });
    setInterval(function () {
      if (paused || document.hidden) return;
      var item = track.querySelector('.car-item');
      if (!item) return;
      var step = item.offsetWidth + 14;
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: step, behavior: 'smooth' });
      }
    }, 4500);
  });

  /* Nouvelle tranche de 2h pendant que la page est ouverte → actualiser uniquement cette section */
  var rot = document.querySelector('[data-rotate-section]');
  if (!rot) return;
  var sectionId = rot.getAttribute('data-rotate-section');
  function msToNextSlot() {
    var two = 2 * 60 * 60 * 1000;
    return two - (Date.now() % two) + 5000;
  }
  function scheduleRefresh() {
    setTimeout(function () {
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId))
        .then(function (r) { if (!r.ok) throw 0; return r.text(); })
        .then(function (html) {
          var host = document.getElementById('shopify-section-' + sectionId);
          if (host) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.querySelector('#shopify-section-' + sectionId) || tmp.firstElementChild;
            if (fresh) host.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function () {})
        .finally(scheduleRefresh);
    }, msToNextSlot());
  }
  scheduleRefresh();
})();
